<template>
    <v-expand-x-transition>
        <v-sheet class="lead-details-sheet" elevation="5" width="400">
            <v-toolbar flat dense color="light-grey">
                <v-toolbar-title>Detalii client</v-toolbar-title>
                <v-spacer />
                <v-btn icon @click="$emit('closeModal')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>

            <v-divider />

            <v-card-text>
                <h3 class="text-lg font-bold mb-4">{{ lead.name }}</h3>

                <v-skeleton-loader v-if="loadingOffersCount" type="chip" class="mb-6"></v-skeleton-loader>
                <v-chip v-else color="primary" outlined class="px-4 mr-2 mb-6" :to="'/oferte/client/' + lead.clientId">
                    <v-icon left size="18">
                        mdi-file-document-multiple-outline
                    </v-icon>
                    Oferte
                    <span v-if="offersCount" class="text-base font-bold px-2">{{
                        offersCount }}</span>
                </v-chip>

                <div v-if="lead.interest" class="mb-6">
                    <div class="flex items-center gap-2 mb-2">
                        <v-label>Interes</v-label>
                        <div class="inline-block w-5 h-5 rounded-full" :class="getColorClass(lead.interest)"></div>
                    </div>
                    <p class="text-base mb-0">{{ getInterestText(lead.interest) }}</p>
                </div>

                <v-skeleton-loader v-if="loadingLeadActions" type="paragraph" class="mb-6"></v-skeleton-loader>
                <div v-else-if="leadActions.length" class="mb-6">
                    <v-label>Actiuni</v-label>
                    <div v-for="action in leadActions" class="mt-2 mb-1">
                        <div class="flex gap-4">
                            <span class="text-green-500 font-bold">{{ getActionTypeText(action.type) }}</span>
                            <span>{{ action.username }}</span>
                            <span>{{ action.created_at | formatDate }}
                                <span v-if="user.rol == 'admin' || user.rol == 'superuser'">
                                    {{ action.created_at | formatTime }}
                                </span>
                            </span>
                        </div>
                        <div v-if="action.msg" class="flex gap-4">
                            <v-icon size="16" class="px-2">mdi-arrow-right-bottom</v-icon>
                            <span class="pt-1">{{ action.msg }}</span>
                        </div>
                    </div>
                </div>

            </v-card-text>
        </v-sheet>
    </v-expand-x-transition>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    props: {
        lead: Object,
        user: Object,
        offersCount: String,
        loadingOffersCount: Boolean,
        leadActions: Array,
        loadingLeadActions: Boolean
    },
    data() {
        return {

        }
    },
    computed: {
        ...mapState('salesLeads', ["interestOptions", "actionTypes"])
    },
    methods: {
        ...mapActions('salesLeads', ["fetchSalesLeadsActions"]),
        getInterestText(interest) {
            const interestOption = this.interestOptions.find(option => option.value === interest)
            return interestOption ? interestOption.text : 'N/A'
        },
        getColorClass(interest) {
            return `bg-${interest}-500`;
        },
        getActionTypeText(type) {
            const actionType = this.actionTypes.find(item => item.value === type)
            return actionType ? actionType.text : 'N/A'
        }
    }
}
</script>